import request from '@/utils/request'

// C-获取OSS直传签名
export function getOssSignature(data) {
	return request({
		url: '/common/get-oss-signature',
		method: 'get',
		params: data
	})
}

// 城市列表
export function getCityList(data) {
	return request({
		url: '/crm/china-area/getAreaTree',
		method: 'get',
		params: data
	})
}

// 所有城市列表
export function getCityLists(data) {
	return request({
		url: '/crm/china-area/getAreaTreeAll',
		method: 'get',
		params: data
	})
}

// C-获取当前登录用户拥有公司的城市列表
export function getCompanyCityList(data) {
	return request({
		url: '/crm/china-area/getCompanyCityList',
		method: 'get',
		params: data
	})
}

// C-公司管理公海设置获取城市下公司信息
export function getEliteList(data) {
	return request({
		url: '/crm/performance/getEliteList',
		method: 'get',
		params: data
	})
}


// C-公司管理公海设置获取城市下公司信息
export function getCityCompanyList(data) {
	return request({
		url: '/crm/tenant/getCityCompanyList',
		method: 'get',
		params: data
	})
}


// C-全部客户查询-待分客户-再分客户-重要客户
export function getAllCustomerListPage(data) {
	return request({
		url: '/crm/customer/getAllCustomerListPage',
		method: 'get',
		params: data
	})
}

// C-全部客户列表上下邻线索（对应 getAllCustomerListPage）
export function getAllCustomerListNeighbor(data) {
	return request({
		url: '/crm/customer/getAllCustomerListNeighbor',
		method: 'get',
		params: data
	})
}

// C-公司公海列表上下邻线索（对应 getCustomerListPage）
export function getCustomerListNeighbor(data) {
	return request({
		url: '/crm/customer/getCustomerListNeighbor',
		method: 'get',
		params: data
	})
}

// C-团队客户列表上下邻线索（对应 getTeamCustomerListPage）
export function getTeamCustomerListNeighbor(data) {
	return request({
		url: '/crm/customer/getTeamCustomerListNeighbor',
		method: 'get',
		params: data
	})
}

// C-点评客户列表上下邻线索（对应 getReviewedCustomerListPage）
export function getReviewedCustomerListNeighbor(data) {
	return request({
		url: '/crm/customer/getReviewedCustomerListNeighbor',
		method: 'get',
		params: data
	})
}


// C-获取线索详情
export function getLeadDetail(data) {
	return request({
		url: '/crm/customer/getLeadDetail',
		method: 'get',
		params: data
	})
}

// C-获取线索跟进记录
export function getLeadFollowUpRecords(data) {
	return request({
		url: '/crm/customer/getLeadFollowUpRecords',
		method: 'get',
		params: data
	})
}


// C-新增跟进记录
export function addCustomer(data) {
	return request({
		url: '/crm/follow-up-record/addCustomer',
		method: 'post',
		data: data
	})
}

// C-客户线索添加黑名单-移除黑名单
export function customerBlack(data) {
	return request({
		url: '/crm/customer-black/customerBlack',
		method: 'post',
		data: data
	})
}


// C-修改星级
export function editStar(data) {
	return request({
		url: '/crm/customer/editStar',
		method: 'post',
		data: data
	})
}


// C-点评客户
export function reviewCustomer(data) {
	return request({
		url: '/crm/customer/reviewCustomer',
		method: 'post',
		data: data
	})
}


// C-查询字典列表 
export function dictionaryPage(data) {
	return request({
		url: '/crm/dict/list',
		method: 'get',
		params: data
	})
}


// C-设置为必跟客户-放入团队公海-加入我的客户
export function setAlwaysFollow(data) {
	return request({
		url: '/crm/customer/setAlwaysFollow',
		method: 'post',
		data: data
	})
}


// C-渠道下拉列表
export function getChannelList(data) {
	return request({
		url: '/crm/channel/getChannelList',
		method: 'get',
		params: data
	})
}

// C-获取公司部门下的客户经理信息（公司公海客户经理下拉选项数据）
// 获取公司组织架构信息
export function deptUserCascadeTree(data) {
	return request({
		url: '/crm/customer/deptUserCascadeTree',
		method: 'get',
		params: data
	})
}

// C-获取管理层审批人员列表
export function getManagementLayerPage(data) {
	return request({
		url: '/crm/customer/getManagementLayerPage',
		method: 'get',
		params: data
	})
}

// C-切换账号专用：获取部门+客户经理级联树
export function deptUserCascadeTreeForSwitch(data) {
	return request({
		url: '/crm/customer/deptUserCascadeTreeForSwitch',
		method: 'get',
		params: data
	})
}

// C-传入公司下的组织架构
export function getCompanyDeptOrgList(data) {
	return request({
		url: '/crm/customer/getCompanyDeptOrgList',
		method: 'get',
		params: data
	})
}

// 获取部门树列表
export function deptTree(data) {
	return request({
		url: '/system/user/deptTree',
		method: 'get',
		params: data
	})
}

// 获取公司部门树列表
export function companyDeptTree(data) {
	return request({
		url: '/system/user/companyDeptTree',
		method: 'get',
		params: data
	})
}

// C-获取当前登录人下面的租户
export function listLoginTenants(data) {
	return request({
		url: '/crm/tenant/listLoginTenants',
		method: 'get',
		params: data
	})
}

// 角色列表
export function rolelist(data) {
	return request({
		url: '/system/role/list',
		method: 'get',
		params: data
	})
}

// C-获取当前登录人下级客户经理
export function getMyChildUserPage(data) {
	return request({
		url: '/crm/customer/getMyChildUserPage',
		method: 'get',
		params: data
	})
}


// C-查询当前登录人下面的客户经理
export function getLoginCustomerPage(data) {
	return request({
		url: '/crm/customer/getLoginCustomerPage',
		method: 'get',
		params: data
	})
}


// C-新增业绩时查询当前登录人下面的所有后勤
export function getLogisticsPage(data) {
	return request({
		url: '/crm/customer/getLogisticsPage',
		method: 'get',
		params: data
	})
}


// C-获取当前登录人公司下所有产品
export function getLoginUserProduct(data) {
	return request({
		url: '/crm/product/getLoginUserProduct',
		method: 'get',
		params: data
	})
}


// C-获取当前登录人公司下所有产品
export function getLoginReferrerPage(data) {
	return request({
		url: '/crm/customer/getLoginReferrerPage',
		method: 'get',
		params: data
	})
}


// C-新增养护计划
export function planAdd(data) {
	return request({
		url: '/crm/maintenance-plan/add',
		method: 'post',
		data: data
	})
}


// C-查询自定义短信模版列表
export function tailorSmslist(data) {
	return request({
		url: '/crm/tailorSms/list',
		method: 'get',
		params: data
	})
}

// C-删除自定义短信模版
export function tailorSmsdelete(data) {
	return request({
		url: '/crm/tailorSms/delete',
		method: 'post',
		data: data
	})
}



// C-新增养护计划
export function sendSocketSms(data) {
	return request({
		url: '/crm/tailorSms/sendSocketSms',
		method: 'post',
		data: data
	})
}

// C-新增养护计划
export function customerDelete(data) {
	return request({
		url: '/crm/customer/delete',
		method: 'post',
		data: data
	})
}


// PC端切换账号
export function changeAccount(data) {
	return request({
		url: '/changeAccount',
		method: 'post',
		data: data
	})
}


// C-获取当前登录人下面客户线索id
export function getLoginDeptCustomerIdPage(data) {
	return request({
		url: '/crm/customer/getLoginDeptCustomerIdPage',
		method: 'get',
		params: data
	})
}

// C-获取当前登录人下面客户线索id
export function getTeamCustomerIdList(data) {
	return request({
		url: '/crm/customer/getTeamCustomerIdList',
		method: 'get',
		params: data
	})
}


// C-获取当前登录人下面客户线索id
export function getCustomerSearchIdList(data) {
	return request({
		url: '/crm/customer/getCustomerSearchIdList',
		method: 'get',
		params: data
	})
}


// C-加入团队中转
export function setTransfer(data) {
	return request({
		url: '/crm/customer/setTransfer',
		method: 'post',
		data: data
	})
}

// 身份照号校验
export function identityVerification(data) {
	return request({
		url: '/identityVerification',
		method: 'post',
		data: data
	})
}


// 登录设置
// 获取登录限制标详情
export function restrictionDetail(data) {
	return request({
		url: '/crm/login-restriction/detail',
		method: 'get',
		params: data
	})
}

// C-新增编辑登录限制标
export function restrictionEditSave(data) {
	return request({
		url: '/crm/login-restriction/editSave',
		method: 'post',
		data: data
	})
}


// 角色列表
export function roleList(data) {
	return request({
		url: '/system/role/list',
		method: 'get',
		params: data
	})
}

// 查询系统参数列表
export function configConfiglist(data) {
	return request({
		url: '/system/configConfig/list',
		method: 'get',
		params: data
	})
}

// 查询系统参数列表
export function getCompanySetName(data) {
	return request({
		url: '/crm/tenant/getCompanySetName',
		method: 'get',
		params: data
	})
}

// C-修改公司视屏话术公司名
export function editCompanySetName(data) {
	return request({
		url: '/crm/tenant/editCompanySetName',
		method: 'post',
		data: data
	})
}


// C-编辑系统参数
export function configConfigedit(data) {
	return request({
		url: '/system/configConfig/edit',
		method: 'post',
		data: data
	})
}

// C-查询用户绑定设备分页
export function userBindDevicepage(data) {
	return request({
		url: '/crm/userBindDevice/page',
		method: 'get',
		params: data
	})
}

// C-查询用户绑定设备列表 -不分页
export function userBindDevicelist(data) {
	return request({
		url: '/crm/userBindDevice/list',
		method: 'get',
		params: data
	})
}

// C-编辑用户绑定设备
export function userBindDeviceedit(data) {
	return request({
		url: '/crm/userBindDevice/edit',
		method: 'post',
		data: data
	})
}

// C-删除用户绑定设备
export function userBindDevicedelete (data) {
	return request({
		url: '/crm/userBindDevice/delete',
		method: 'post',
		data: data
	})
}

// C-用户调库提醒
export function UserTransferRemind(data) {
	return request({
		url: '/crm/customer/getUserTransferRemind',
		method: 'get',
		params: data
	})
}

// C-其他状态分配线索
export function allocateOtherCustomer (data) {
	return request({
		url: '/crm/customer/allocateOtherCustomer',
		method: 'post',
		data: data
	})
}

